import { SignedAngle, Vectors, TranslateAndRotate } from "@project-rouge/rg-three";
import { getRealMusclePoint } from "./index167.js";
import { MuscleToVector } from "./index55.js";
import { Vector3 } from "three";
const mVec = new Vector3();
const realMuscleStart = new Vector3();
function addItemsToMuscle(building, muscle, addToBuilding, addToMuscle) {
  if (!addToBuilding.length)
    return;
  MuscleToVector(muscle, mVec);
  getRealMusclePoint(muscle, 0, realMuscleStart);
  muscle.gFUnits = addToMuscle;
  const angle = SignedAngle(Vectors.Right, mVec);
  TranslateAndRotate(addToBuilding, angle, realMuscleStart);
  building.children = building.children.concat(addToBuilding);
}
export {
  addItemsToMuscle
};
//# sourceMappingURL=index3.js.map
